module.exports = __webpack_public_path__ + "static/summer-55dc68b0d2c7c923bc5ccb6e88af3ffb.jpg";